module.exports = __webpack_public_path__ + "static/media/022-Golf de i'lile de Montreal.ec726a52.jpg";